import { render } from "./HandlePurchaseStatusModal.vue?vue&type=template&id=01202f21&scoped=true"
import script from "./HandlePurchaseStatusModal.vue?vue&type=script&lang=js"
export * from "./HandlePurchaseStatusModal.vue?vue&type=script&lang=js"

import "./HandlePurchaseStatusModal.vue?vue&type=style&index=0&id=01202f21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01202f21"]])

export default __exports__